$(document).ready(() => {
  $('.attachinary-input').attachinary()
})
